import { Badge } from '@/components/ui/badge';
import { type VariantProps } from 'class-variance-authority';

type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'destructive' | 'orange' | 'muted';

function getStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'PENDING':
      return 'warning';
    case 'PAID':
      return 'primary';
    case 'COMPLETED':
      return 'success';
    case 'PAID_CALLBACK_FAILED':
      return 'orange';
    case 'EXPIRED':
      return 'muted';
    case 'CANCELLED':
      return 'muted';
    case 'FAILED':
      return 'destructive';
    default:
      return 'default';
  }
}

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const variant = getStatusVariant(status);
  return (
    <Badge variant={variant} className={className}>
      {status.replace('_', ' ')}
    </Badge>
  );
}
